'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _capitalize2 = require('lodash/capitalize');

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _FormattingUtils = require('../../utils/FormattingUtils');

var _FormattingUtils2 = _interopRequireDefault(_FormattingUtils);

var _CaseActivity = require('./CaseActivity');

var _CaseActivity2 = _interopRequireDefault(_CaseActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var getNameOrDefault = _FormattingUtils2.default.getNameOrDefault;

var RepresentativeAssignment = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(RepresentativeAssignment, _Component);

  function RepresentativeAssignment() {
    _classCallCheck(this, RepresentativeAssignment);

    return _possibleConstructorReturn(this, (RepresentativeAssignment.__proto__ || Object.getPrototypeOf(RepresentativeAssignment)).apply(this, arguments));
  }

  _createClass(RepresentativeAssignment, [{
    key: 'getBodyText',
    value: function getBodyText() {
      var _props$activity = this.props.activity,
          previous_representative = _props$activity.previous_representative,
          representative_type = _props$activity.representative_type,
          representative = _props$activity.representative;


      var body = (0, _capitalize3.default)(representative_type) + ' owner -';

      if (representative) {
        body = body + ' Set to ' + getNameOrDefault(representative) + '.';
      }

      if (previous_representative) {
        body = body + ' Removed ' + getNameOrDefault(previous_representative) + '.';
      }

      return body;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_CaseActivity2.default, _extends({
        activity_body: this.getBodyText(),
        dot: 'icon',
        icon: 'user'
      }, this.props));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return RepresentativeAssignment;
}(_react.Component), _class2.defaultProps = {
  previous_representative: null,
  representative: null
}, _class2.propTypes = {
  activity: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    previous_representative: _propTypes2.default.object,
    representative: _propTypes2.default.object,
    representative_type: _propTypes2.default.string.isRequired
  }).isRequired
}, _temp)) || _class) || _class;

var _default = RepresentativeAssignment;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/common-activities/RepresentativeAssignment.js');
  reactHotLoader.register(RepresentativeAssignment, 'RepresentativeAssignment', '/app/src/components/common-activities/RepresentativeAssignment.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/RepresentativeAssignment.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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